import * as blocLiensStyles from "../../../styles/admissions/admissions.module.scss";
import {getDate, getHour} from "../../../utils/parsing";

import IconContainer from "../IconContainer";
import React from "react";
import SpecialLink from "./SpecialLink";
import clsx from "clsx";
import {getI18n, useTranslation} from "react-i18next";

const EventInfo = ({title, event, color}) => {
    const getLanguage = () => getI18n().language
    const {t} = useTranslation();

    if (!event) {
        return <></>
    }

    
    const start_day = getDate(event.start_date, " ", {month: "long"}, getLanguage());
    const end_day = getDate(event.end_date, " ", {month: "long"}, getLanguage());
    const start_hour = getHour(event.start_date);
    const end_hour = getHour(event.end_date);
    let title1 = "";
    let title2 = "";

    

    if (event && event.event_location) {
        if (event.event_location.room) {
            title1 = `${event.event_location.room}`;
        }
        if (event.event_location.event_address) {
            const ea = event.event_location.event_address;
            const addr = [];
            for (let key of ["address", "zip", "city", "country"]) {
                if (ea[key]) {
                    addr.push(ea[key]);
                }
            }
            title2 = addr.join(", ");
        }
    }

    return (
        <>
            <div
                className={clsx(
                    blocLiensStyles.contentTitleInfo, {
                        [blocLiensStyles.darkBlocLiensEntete]: color === "BLACK",
                        [blocLiensStyles.redBlocLiensEntete]: color !== "BLACK"
                    })
                }
            >
                <div className={blocLiensStyles.itemTitleInfo}>
                    <h2 className={blocLiensStyles.relatedTitleEventInfo}>
                        {t("event.page.widget")}
                    </h2>
                </div>
            </div>
            <div
                className={clsx(
                    blocLiensStyles.contentTitleInfo, {
                        [blocLiensStyles.darkActionListCorps]: color === "BLACK",
                        [blocLiensStyles.redActionListCorps]: color !== "BLACK"
                    })
                }
            >
                {
                    <div className={clsx(blocLiensStyles.margin, blocLiensStyles.specialLinkEventInfo)}>
                        <SpecialLink suppressHydrationWarning={true}
                            textTransform="none"
                            color="#706f6f"
                            title={
                                start_day !== end_day
                                    ? t("event.page.date.several.days", {
                                        start_day: start_day,
                                        start_hour: start_hour,
                                        end_day: end_day,
                                        end_hour: end_hour,
                                    })
                                    : t("event.page.date.single.day", {
                                        start_day: start_day,
                                        start_hour: start_hour,
                                        end_hour: end_hour,
                                    })
                            }
                            icon={
                                <IconContainer
                                    icon="CALENDAR"
                                    color={color}
                                    size={25}
                                    variant="outlined"
                                    svgClassname={blocLiensStyles.actionSVGIcon}
                                    style={{padding: "5px"}}
                                />
                            }
                            disable
                            arrowDisable
                            lowcase
                            isEventInfo={true}
                        />
                    </div>
                }

                {event?.event_location && (
                    <>
                        <div
                            className={clsx(
                                blocLiensStyles.separation,
                                blocLiensStyles.margin,
                            )}
                        ></div>
                        <div className={clsx(
                            blocLiensStyles.margin,
                            blocLiensStyles.specialLinkEventInfo)}
                        >
                            <SpecialLink
                                textTransform="none"
                                title={title1}
                                subtitle={title2}
                                color="#706f6f"
                                icon={
                                    <IconContainer
                                        icon="LOCATION"
                                        color={color}
                                        size={25}
                                        variant="outlined"
                                        svgClassname={blocLiensStyles.actionSVGIcon}
                                        style={{padding: "5px"}}
                                    />
                                }
                                disable
                                arrowDisable
                                lowcase
                                isEventInfo={true}
                            />
                        </div>
                    </>
                )}

                {event?.organizer && (
                    <>
                        <div
                            className={clsx(
                                blocLiensStyles.separation,
                                blocLiensStyles.margin,
                            )}
                        ></div>
                        <div>
                            <SpecialLink
                                textTransform="none"
                                color="#706f6f"
                                subtitle={event.organizer}
                                title={t("event.page.info.organized.by")}
                                icon={
                                    <IconContainer
                                        icon="AWARD"
                                        color={color}
                                        size={25}
                                        variant="outlined"
                                        svgClassname={blocLiensStyles.actionSVGIcon}
                                        style={{padding: "5px"}}
                                    />
                                }
                                disable
                                arrowDisable
                                lowcase
                                isRelatedContent={true}
                            />
                        </div>
                    </>
                )}
            </div>
        </>
    );
};

export default EventInfo;
